<template>
  <form class="template-form" @submit.prevent="submit">
    <Field
      label="Template name"
      @input="$v.resource.name.$touch()"
      v-model="resource.name"
      helpText="This will be shown on the create new website page"
      :error="nameError"/>

    <Field
      label="Template slug"
      @input="$v.resource.slug.$touch()"
      v-model="resource.slug"
      helpText="This is HTML body class, it should be hyphenated and lowercase"
      :error="slugError"/>

    <Field
      disableEditor
      type="textarea"
      label="Template content"
      v-model="jsonContent"
      helpText="JSON Please"
      :error="contentError"/>

    <btn primary>Save Changes</btn>
  </form>
</template>

<script>
import form from '@/mixins/form'

import Btn from '@/components/Btn'

import {errorMessages} from '@/lib/error_messages'
import {required} from 'vuelidate/lib/validators'

export default {
  name: 'template-form',

  data() {
    return {
      fieldsLoaded: false
    }
  },

  mixins: [form],

  computed: {
    ...errorMessages([
      'name',
      'slug',
      'content'
    ]),

    jsonContent: {
      get() {
        let json = typeof this.resource.content === 'object'

        return json ? JSON.stringify(this.resource.content) : this.resource.content
      },

      set(newValue) {
        // let json = typeof this.resource.content === 'object'

        // let out = this.resource.content ? JSON.parse(newValue) : newValue

        this.resource.content = newValue

        // this.$emit('input', out)
      }
    }
  },

  components: {
    Btn
  },

  validations: {
    resource: {
      name: {required},
      slug: {required},
      content: {required}
    }
  },

  mounted() {
    this.fieldsLoaded = false
  }
}
</script>

<style lang="sass">
</style>
